module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_moere_og_romsdal_pos.c8ece4fb.pdf";